import Glide from '@glidejs/glide'
import { useState, useEffect } from 'react'


const Test = () => {
    
        return (
          <div>
            <button type="submit" className="btn" >Click me!</button>
          </div>
        );
      
}
export default Test;
